import { Component } from '@angular/core';
import {ChunkErrorService} from '../../../services/utility/chunk-error.service';

@Component({
  selector: 'app-reload-banner',
  standalone: true,
  templateUrl: './reload-banner.component.html',
  styleUrl: './reload-banner.component.scss'
})
export class ReloadBannerComponent {
  error

  constructor(private chunkError: ChunkErrorService) {
    this.chunkError.error$.subscribe((error) => this.error = error);
  }

  reload() {
    window.location.reload();
  }

  reloadWithForcedHardReload() {
    window.location.href = window.location.href.split('?')[0] + '?v=' + Date.now();
  }
}
